module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/197-melilla-d9a7451ffdc3b4bce5d19f3a454508c4.svg";